/**
 * Returns true if we're on a browser environment.
 */
export default function onBrowser() {
  return typeof window === "object";
}
